export default {
  title: 'Impression de reçus',
  sections: {
    destination: 'Impression vers',
  },
  printers: {
    inner: {
      title: 'Imprimante intégrée',
    },
    external: {
      title: 'Imprimante externe',
      width_unset: 'Largeur de papier non définie',
      connect_hint: "Connectez une imprimante pour l'utiliser",
      disconnect_confirm: 'Déconnecter cette imprimante ?',
      disconnect_confirm_description: 'Vous devrez la reconfigurer.',
      disconnect_confirm_ok: 'Oui, déconnecter',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Prête',
      title: 'Prête à imprimer',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Papier faible',
      title: 'Le papier est presque épuisé',
      description: "Remplacez le rouleau bientôt. L'impression continue.",
    },
    busy: {
      label: 'Occupée',
      title: 'Imprimante occupée',
      description: '{{name}} termine une autre tâche.',
    },
    not_configured: {
      label: 'Non configurée',
      title: 'Non configurée',
      description: '{{name}} doit être configurée avant de pouvoir imprimer.',
    },
    offline: {
      label: 'Hors ligne',
      title: "N'imprime pas",
      description: '{{name}} est hors ligne. Les nouvelles commandes ne sont pas imprimées.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Hors ligne',
      description_idle: "{{name}} n'est pas connectée.",
    },
    cover_open: {
      label: 'Capot ouvert',
      title: 'Le capot est ouvert',
      description: "Fermez le capot de l'imprimante pour reprendre l'impression.",
    },
    paper_empty: {
      label: 'Plus de papier',
      title: 'Plus de papier',
      description: "Remplacez le rouleau pour reprendre l'impression.",
    },
    wrong_paper: {
      label: 'Papier incorrect',
      title: 'Papier incorrect',
      description: 'Le rouleau chargé ne correspond pas à la largeur de papier configurée.',
    },
    cutter_error: {
      label: 'Erreur de coupe',
      title: 'Erreur de coupe',
      description: "Vérifiez que le couteau n'est pas bloqué, puis réessayez.",
    },
    overheat: {
      label: 'Surchauffe',
      title: 'Imprimante trop chaude',
      description: "Laissez {{name}} refroidir avant d'imprimer à nouveau.",
    },
    error: {
      label: 'Erreur',
      title: "Erreur d'imprimante",
      description: '{{name}} a signalé une erreur et nécessite une intervention.',
    },
    connecting: {
      label: 'Connexion en cours…',
      title: 'Connexion en cours…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Non connectée',
      title: 'Non connectée',
      description: "{{name}} n'est pas connectée.",
    },
  },
  form: {
    auto_print: {
      label: 'Imprimer automatiquement les nouvelles commandes',
      not_ready:
        "L'impression auto est activée mais l'imprimante externe n'est pas prête. Les commandes ne seront pas imprimées.",
    },
    print_copies: {
      label: 'Copies par commande',
      hint: "Activez l'impression auto pour définir les copies",
      decrease: 'Diminuer les copies',
      increase: 'Augmenter les copies',
    },
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
  },
  buttons: {
    test_print: 'Impression test',
    configure_external: 'Configurer',
    connect_external: 'Connecter une imprimante',
    disconnect_external: 'Déconnecter',
    retry_connection: 'Réessayer la connexion',
    cancel: 'Annuler',
  },
};
